const base = require('adyen_SFRA/adyenCheckout');

const store = require('adyen_SFRA/../../../store');

const _require4 = require('adyen_SFRA/adyen_checkout/validateComponents');

const {validateComponents} = _require4;

const _require3 = require('./adyen_checkout/helpers');

const {assignPaymentMethodValue} = _require3;
const {showValidation} = _require3;
const {paymentFromComponent} = _require3;


const { addDocumentDelegatedListener } = require('./common/utils/domEvents')

base.validateAdyenPayment = function validateAdyenPayment() {
  if (store.paypalTerminatedEarly) {
    paymentFromComponent({
      cancelTransaction: true,
      merchantReference: document.querySelector('#merchantReference').value
    });
    store.paypalTerminatedEarly = false;
  }
  if (document.querySelector('#selectedPaymentOption').value === 'AdyenPOS') {
    document.querySelector('#terminalId').value = document.querySelector('#terminalList').value;
  }

  if (document.querySelector('#selectedPaymentOption').value === 'AdyenComponent') {
    assignPaymentMethodValue();
    validateComponents();
    return showValidation();
  }
  return true;
}

/* Control filled value for cardHolder adyen field for floating labels */
function handleCardHolderChanges() {
  const cardHolderInputElement = this;
  const adyenField = cardHolderInputElement.closest('.adyen-checkout__field');
  if (cardHolderInputElement.value !== '') {
    adyenField.classList.add('adyen-checkout__field--filled')
  } else {
    adyenField.classList.remove('adyen-checkout__field--filled');
  }
}
addDocumentDelegatedListener(
  'input',
  '.adyen-checkout__card__holderName__input',
  handleCardHolderChanges);

base.handleAdyenPaymentErrors = function handleAdyenPaymentErrors(data) {
  store.formErrorsExist = 'fieldErrors' in data;
};

module.exports = base;
